import * as React from 'react';
import {
  RadioGroup,
  RadioLabel,
  RadioInput,
  RadioLabelText,
} from './Radio.styled';

export const Radio = ({
  label,
  title,
  placeholder,
  'aria-label': ariaLabel,
  ...props
}) => {
  const id = `id_${props.name}_${props.value}`;
  const onChangeCalled = React.useRef(false);

  const onChange = (event) => {
    onChangeCalled.current = true;
    props.onChange(event);

    onChangeCalled.current = false;
  };

  const onLabelClick = () => {
    const radio = document.querySelector(`input[name="${props.name}"]#${id}`);
    if (!onChangeCalled.current && !radio.checked) {
      radio.checked = !radio.checked;
      props.onChange({ target: radio });
    }
  };

  return (
    <RadioLabel htmlFor={id} aria-label={ariaLabel} onClick={onLabelClick}>
      <RadioInput id={id} name={props.name} {...props} onChange={onChange} />
      <RadioLabelText $checked={props.checked} onClick={onLabelClick}>
        {label}
      </RadioLabelText>
    </RadioLabel>
  );
};

Radio.Group = RadioGroup;
